<template>
  <ContainerMain>

    <BlockHeader :additionalClasses="'pb-[3px]'"/>

    <div class="flex flex-col justify-start items-start text-center mt-12 pt-[1px] pb-[1px] space-y-8">
      <div class="flex flex-col space-y-2 text-left mb-12 md:mb-24">
        <h1 class="text-[80px] font-bold mb-2">{{ error?.statusCode }}</h1>
        <p class="text-3xl font-bold !mt-[7px]">
          <template v-if="error?.statusCode == 404">
            <span class="block max-w-[160px] leading-10">Nothing found.</span>
          </template>
          <template v-else>
            <div v-if="error?.statusCode >= 500" v-html="error?.stack"></div>
          </template>
        </p>
      </div>

      <div class="self-end pt-[12px]">
        <img src="@/assets/images/elements/error.svg" alt="" class="w-[364px] h-[389px] mt-[4px] ml-0 mb-[3px]"/>
      </div>
    </div>

  </ContainerMain>
</template>

<script setup lang="ts">
import type { PropType } from 'vue';
const props = defineProps({
  error: {
    type: Object as PropType<{ statusCode?: number; stack?: string }>,
    required: true,
  },
});

useSeoMeta({
  title: 'Error - Page Not Found',
});
</script>

<style scoped>
</style>
